
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[typeOrDistance]/[location]",
      function () {
        return require("private-next-pages/[typeOrDistance]/[location]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[typeOrDistance]/[location]"])
      });
    }
  